import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    List,
    ListItem,
    ListItemText,
    Typography,
    IconButton,
    Grid,
    Modal,
    Alert,
    CircularProgress,
} from "@mui/material/";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles";


/**
 * Excluded Audits List  Component
 */
export default ({
    openExlcusionReasonList,
    onExcludedAssetListClose,
    excludedAssetList,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={openExlcusionReasonList}
            onClose={onExcludedAssetListClose}
            aria-labelledby="message-modal"
            aria-describedby="exclusion-reason-modal"
        >
            <Grid container sx={styles.modalBox}>
                <Grid item xs={8}>
                    <Typography
                        id="modal-description"
                        sx={styles.modalMessage}
                        variant="h6"
                        gutterBottom
                    >
                        {t("excludedAssets")}
                    </Typography>
                </Grid>
                <Grid item xs={4} sx={styles.closeButton}>
                    <IconButton
                        aria-label="close"
                        onClick={onExcludedAssetListClose}
                    >
                        <CloseIcon color="primary" />
                    </IconButton>
                </Grid>
                {excludedAssetList && (
                    <>
                        <Grid
                            container
                            spacing={1}
                            sx={styles.excludedListHeader}
                        >
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">
                                    {t("VIN number")}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">
                                    {t("exclusionReason")}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={styles.excludedList}>
                            {excludedAssetList.map((item) => (
                                <React.Fragment key={item.vin}>
                                    <Grid
                                        key={`${item.vin}`}
                                        item
                                        xs={6}
                                        sx={{
                                            alignSelf: "center",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="caption">
                                            {item.vin}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        key={`${item.vin}- ${item.exclusionReason}`}
                                        item
                                        xs={6}
                                        sx={{ textAlign: "center" }}
                                    >
                                        <Typography variant="caption">
                                            {item.exclusionReason}
                                        </Typography>
                                    </Grid>
                                </React.Fragment>
                            ))}
                        </Grid>
                    </>
                )}
            </Grid>
        </Modal>
    );
};
